<template>
  <v-container>
    <v-layout
      wrap
      justify-space-around
      fill-height
      align-center
      v-on:mouseover="flags.updateImage = true"
      v-on:mouseleave="flags.updateImage = false"
    >
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <!-- File picker -->
            <FileAttachment v-on:selected-file="onSelectedFile" center />
            <!-- File picker -->
            <v-list v-if="notice" two-line>
              <div v-if="notice && notice.files && notice.files.length > 0">Documentos anexados</div>
              <template v-for="(item, index) in notice.files">
                 <v-chip :key="index">
                  <v-avatar>
                   <v-icon>chrome_reader_mode</v-icon>
                </v-avatar>
                 {{ item.name}} {{'   '+(item.size/(1024*1024)).toFixed(2)+'Mb'}}  <v-icon @click="erase(index)" color="grey lighten-1">clear</v-icon>
                </v-chip>
                <!-- <v-list-tile avatar :key="index">
                  <v-list-tile-avatar>
                    <v-icon>chrome_reader_mode</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="item.type+' '+(item.size/(1024*1024)).toFixed(2)+'Mb'"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon ripple @click="erase(index)">
                      <v-icon color="grey lighten-1">clear</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile> -->
              </template>
            </v-list>

            <v-flex xs12 class="mt3"></v-flex>
                
            
          </v-flex>
    <v-dialog v-model="modals2.limite" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ modals2.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <b>{{ modals2.descripcion }}</b>
            </v-layout>
            <v-spacer />
            <v-layout class="justify-center">
              <v-btn flat  @click="modals2.limite = false;"> Aceptar </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
        </v-layout>
      </v-flex>
    <alert v-model="toast.alert" title="Aviso" :description="toast.description"></alert>

    </v-layout>
  </v-container>
</template>

<script>
import alert from "../../Dialogs/Alert";
import FileAttachment from "../../Tools/FileAttachment2";
export default {
  components: {
    alert,
    FileAttachment
  },
  props: ["notice","value"],
  data: () => ({
    flags: {
      updateImage: false
    },
    modals: {
      image: false,
      warning: false,
      size: false
    },
     modals2:{
      title: "Atención",
      descripcion:"No se puede agregar el archivo dado que se excederia el limite permitido 15 MB",
      limite: false
    },
    noticeForm: {
      files: [],
    },
     toast: {
      alert: false,
      description: ""
    },
  }),
   watch: {
    value() {
      if (this.value == null || this.value == []) {
        this.noticeForm = {
          files: []
        };
      }
    }
  },
  methods: {
    onSelectedFile(file) {
      //old attach
      //this.notice.files.push(file);
        

    var sizseTotal=0;

    if(this.value !== null){
        //se saca un total
        this.value.map(function(value, key) {   
        console.log("key:"+key+ "value:"+value.size);
        sizseTotal += value.size;
      });
    }
    // var textMB = (15800000/(1024*1024)).toFixed(2)+'Mb';
    // this.toast.description = "File actual peso :"+file.size+"peso acomulado :"+sizseTotal+" MB permitidos: "+textMB ;
    // this.toast.alert = true;        


    if(sizseTotal+file.size<=15800000){
    //   this.value.push(file);
      this.notice.files.push(file);
      this.value.push(file);
    }else{
        this.modals2.limite=true;
    //   this.toast.description = "No se puede agregar el archivo dado que se excederia el limite permitido 15 MB";
    //    this.toast.alert = true;        
    }


      //this.noticeForm.files.push(file);
    },
    erase(index) {
      this.notice.files.splice(index, 1);
      this.value.splice(index, 1);
    }
  }
};
</script>

<style>
</style>
